/** @format */
import {
	GetDistributionDetailsResponse,
	ProductTypeRequest,
} from "_clients/BFFClient"
import { BuyMoreBoostsDistributionRequest } from "../BuyMorePopin/BuyMorePopin.types"
import { SearchParamsType } from "_components/organisms/CreditDispatchDashboard/CreditDispatchDashboard.types"

export type ConsumptionSummaryProps = {
	productType?: ProductTypeRequest[]
	consumptionInfo: GetDistributionDetailsResponse
	showDispatchButton?: boolean
	dispatchUrl?: string
	buyMoreBoostsDistribution: BuyMoreBoostsDistributionRequest
	isLoading: boolean
	searchParams: SearchParamsType
}

export const ProductTypeKeysMapper = {
	BoostListe: "Boost Liste",
	BoostExtend: "Boost Extend",
	BoostAlert: "Boost Email",
	AnnonceOr: "Annonce Or",
	AnnonceArgent: "Annonce Argent",
}
